import { Button, ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import { GrHelp } from 'react-icons/gr';
import { BsArrowsCollapse, BsArrowsExpand } from 'react-icons/bs';
import React from 'react';
import { useAppState } from '../../AppContext';

const Control = () => {
  const [
    {
      visibleMetadataColumns,
      metadataColumnVisibility,
      clustersInTable: clusters,
      groupBy,
      sortBy,
      sortGroupsBy
    },
    dispatch
  ] = useAppState();

  if (!clusters) {
    return null;
  }

  const expandedClusters = clusters.filter((c) => c.expanded).length > 0;
  const collapsedClusters = clusters.filter((c) => !c.expanded).length > 0;

  return (
    <div
      style={{
        position: 'sticky',
        zIndex: '1000',
        top: '0px',
        left: '0px',
        background: 'white',
        width: '100%'
      }}
    >
      <ButtonGroup>
        {collapsedClusters && (
          <Button
            variant="outline-secondary"
            onClick={(ev) => dispatch({ type: 'EXPAND_ALL_CLUSTERS' })}
          >
            <BsArrowsExpand /> Expand all groups
          </Button>
        )}

        {expandedClusters && (
          <Button
            variant="outline-secondary"
            onClick={(ev) => dispatch({ type: 'COLLAPSE_ALL_CLUSTERS' })}
          >
            <BsArrowsCollapse /> Collapse all groups
          </Button>
        )}

        <DropdownButton
          as={ButtonGroup}
          variant="outline-secondary"
          title="Keyword sorting"
        >
          <Dropdown.Item
            eventKey="1"
            onClick={() =>
              dispatch({ type: 'SET_KEYWORD_ORDER', order: 'ALPHABETICAL' })
            }
          >
            Alphabetical
          </Dropdown.Item>
          <Dropdown.Item
            eventKey="1"
            onClick={() =>
              dispatch({ type: 'SET_KEYWORD_ORDER', order: 'CLUSTER' })
            }
          >
            By Cluster
          </Dropdown.Item>{' '}
          <Dropdown.Item
            eventKey="1"
            onClick={() =>
              dispatch({ type: 'SET_KEYWORD_ORDER', order: 'FREQUENCY' })
            }
          >
            By Frequency
          </Dropdown.Item>
        </DropdownButton>

        {visibleMetadataColumns.length < metadataColumnVisibility.length && (
          <DropdownButton
            as={ButtonGroup}
            variant="outline-secondary"
            title="Show hidden column"
          >
            {metadataColumnVisibility
              .filter((col) => !col.visible)
              .map((col) => (
                <Dropdown.Item
                  key={col.name}
                  eventKey="1"
                  onClick={() =>
                    dispatch({
                      type: 'TOGGLE_METADATA_COLUMN',
                      columnName: col.name
                    })
                  }
                >
                  {col.name}
                </Dropdown.Item>
              ))}
          </DropdownButton>
        )}

        {metadataColumnVisibility.length > 0 && (
          <DropdownButton
            as={ButtonGroup}
            variant="outline-secondary"
            title="Group by"
          >
            <Dropdown.Item
              onClick={() =>
                dispatch({
                  type: 'GROUP_BY',
                  columnName: 'None'
                })
              }
            >
              {groupBy === 'None' ? <b>None</b> : 'None'}
            </Dropdown.Item>

            <Dropdown.Divider />

            <Dropdown.Item
              key={'Cluster'}
              onClick={() =>
                dispatch({
                  type: 'GROUP_BY',
                  columnName: 'Cluster'
                })
              }
            >
              {groupBy === 'Cluster' ? <b>Cluster</b> : 'Cluster'}
            </Dropdown.Item>

            <Dropdown.Divider />

            {metadataColumnVisibility
              .filter((col) => col.name !== 'Cluster Keywords')
              .map((col) => (
                <Dropdown.Item
                  key={col.name}
                  onClick={() =>
                    dispatch({
                      type: 'GROUP_BY',
                      columnName: col.name
                    })
                  }
                >
                  {groupBy === col.name ? <b>{col.name}</b> : col.name}
                </Dropdown.Item>
              ))}
          </DropdownButton>
        )}

        {metadataColumnVisibility.length > 0 && (
          <DropdownButton
            as={ButtonGroup}
            variant="outline-secondary"
            title="Sort Groups By"
          >
            <Dropdown.Item
              onClick={() =>
                dispatch({
                  type: 'SORT_GROUPS_BY',
                  sortGroupsBy: 'numDocs'
                })
              }
            >
              {sortGroupsBy === 'numDocs' ? <b>Number of docs</b> : 'Number of docs'}
            </Dropdown.Item>

            <Dropdown.Item
              onClick={() =>
                dispatch({
                  type: 'SORT_GROUPS_BY',
                  sortGroupsBy: 'groupName'
                })
              }
            >
              {sortGroupsBy === 'groupName' ? <b>Group name</b> : 'Group name'}
            </Dropdown.Item>

          </DropdownButton>
        )}


        {metadataColumnVisibility.length > 0 && (
          <DropdownButton
            as={ButtonGroup}
            variant="outline-secondary"
            title="Sort by"
          >
            <Dropdown.Item
              onClick={() =>
                dispatch({
                  type: 'SORT_BY',
                  columnName: 'Cluster'
                })
              }
            >
              {sortBy === 'Cluster' ? <b>Cluster</b> : 'Cluster'}
            </Dropdown.Item>

            <Dropdown.Divider />

            <Dropdown.Item
              onClick={() =>
                dispatch({
                  type: 'SORT_BY',
                  columnName: 'Title'
                })
              }
            >
              {sortBy === 'Title' ? <b>Title</b> : 'Title'}
            </Dropdown.Item>

            <Dropdown.Divider />

            {metadataColumnVisibility
              .filter((col) => col.name !== 'Cluster Keywords')
              .map((col) => (
                <Dropdown.Item
                  key={col.name}
                  onClick={() =>
                    dispatch({
                      type: 'SORT_BY',
                      columnName: col.name
                    })
                  }
                >
                  {sortBy === col.name ? <b>{col.name}</b> : col.name}
                </Dropdown.Item>
              ))}
          </DropdownButton>
        )}

        <Button
          onClick={() =>
            dispatch({
              type: 'SET_ONBOARIDNG_MODAL_OPEN',
              onboardingModalOpen: true
            })
          }
          variant="outline-secondary"
        >
          <GrHelp /> Show help
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default Control;
